module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embed-form"
  }, [_c('h4', {
    staticClass: "embed-form__heading"
  }, [_vm._v("Embed")]), _vm._v(" "), _c('p', [_vm._v("\n    Copy the code bellow to embed the entire visualization in your website.\n  ")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control embed-form__code mb-4",
    attrs: {
      "readonly": ""
    }
  }, [_vm._v(_vm._s(_vm.overviewCode))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51c31cbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmbedForm.vue
// module id = 604
// module chunks = 1